export default "__VITE_ASSET__pFFZnb7d__"